import { useState } from 'react'
import { FinalizeSampleModal } from './FinalizeSampleModal'
import type { Requisition } from '../../types/types'
import { CheckIcon, Mtds } from 'prove-common'

type FinalizeSampleButtonProps = {
  requisition: Requisition
}

export const FinalizeSampleButton = ({
  requisition
}: FinalizeSampleButtonProps) => {
  const [isModalOpen, setModalOpen] = useState(false)
  return (
    <div>
      <Mtds.Button data-variant='primary' onClick={() => setModalOpen(true)}>
        <CheckIcon />
        Ferdigstill og avskriv
      </Mtds.Button>
      {isModalOpen && (
        <FinalizeSampleModal
          requisition={requisition}
          isOpen={isModalOpen}
          setOpen={setModalOpen}
        />
      )}
    </div>
  )
}
